/* Doguers — comportamento das seções dg-* (menu, busca, carrosséis, produto, coleção). */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Cabeçalho ---------- */
  function iniciarCabecalho() {
    var header = $('[data-dg-header]');
    if (!header) return;

    var faixa = $('.dg-ann');
    var medir = function () {
      var alturaFaixa = faixa ? faixa.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--dg-ann-h', alturaFaixa + 'px');
      document.documentElement.style.setProperty('--dg-header-h', alturaFaixa + header.offsetHeight + 'px');
    };
    medir();
    window.addEventListener('resize', medir);

    // Menu: no computador abre ao passar o mouse (e no clique); no celular, no clique.
    var nav = $('[data-dg-nav]', header);
    var botao = $('[data-dg-menu-toggle]', header);
    var menu = $('[data-dg-menu]', header);
    if (nav && botao && menu) {
      var computador = window.matchMedia('(min-width: 1000px) and (hover: hover)');
      var timer = null;
      var definir = function (abrir) {
        clearTimeout(timer);
        menu.classList.toggle('is-aberto', abrir);
        menu.setAttribute('aria-hidden', String(!abrir));
        botao.setAttribute('aria-expanded', String(abrir));
        botao.setAttribute('aria-label', abrir ? 'Fechar menu' : 'Abrir menu');
        header.classList.toggle('menu-aberto', abrir);
        if (abrir) medir();
      };
      botao.addEventListener('click', function (e) {
        e.stopPropagation();
        definir(!menu.classList.contains('is-aberto'));
      });
      nav.addEventListener('mouseenter', function () { if (computador.matches) definir(true); });
      nav.addEventListener('mouseleave', function () {
        if (!computador.matches) return;
        timer = setTimeout(function () { definir(false); }, 150);
      });
      document.addEventListener('click', function (e) {
        if (menu.classList.contains('is-aberto') && !nav.contains(e.target)) definir(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('is-aberto')) { definir(false); botao.focus(); }
      });
      // Subcategorias em sanfona (celular)
      $$('[data-dg-sub-toggle]', menu).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          var item = b.closest('.dg-menu__item');
          var aberto = item.classList.toggle('is-aberto');
          b.setAttribute('aria-expanded', String(aberto));
        });
      });
    }

    var lupa = $('[data-dg-busca-toggle]', header);
    var barra = $('.dg-header', header);
    if (lupa && barra) {
      lupa.addEventListener('click', function () {
        var abrir = !barra.classList.contains('dg-header--busca');
        barra.classList.toggle('dg-header--busca', abrir);
        lupa.setAttribute('aria-expanded', String(abrir));
        if (abrir) { var campo = $('#DgSearch', header); if (campo) campo.focus(); }
        setTimeout(medir, 300);
      });
    }

    var busca = $('[data-dg-search]', header);
    if (busca) {
      var seletor = $('[data-dg-search-tipo]', busca);
      if (seletor) {
        seletor.addEventListener('change', function () {
          var opcao = seletor.options[seletor.selectedIndex];
          var campo = $('input[name="q"]', busca);
          if (opcao && opcao.hasAttribute('data-dg-colecao') && !campo.value.trim()) {
            if (window.dgCarregando) window.dgCarregando();
            window.location.href = opcao.value;
          }
        });
      }
      busca.addEventListener('submit', function (e) {
        var tipo = $('[data-dg-search-tipo]', busca);
        var campo = $('input[name="q"]', busca);
        var opcao = tipo && tipo.options[tipo.selectedIndex];
        if (opcao && opcao.hasAttribute('data-dg-colecao')) {
          // Categoria = coleção: sem palavra digitada, abre a coleção; com palavra, busca na loja toda
          if (!campo.value.trim()) {
            e.preventDefault();
            if (window.dgCarregando) window.dgCarregando();
            window.location.href = opcao.value;
          }
          return;
        }
        if (tipo && tipo.value) {
          var termo = campo.value.trim();
          var filtro = 'product_type:"' + tipo.value.replace(/"/g, '') + '"';
          campo.value = termo ? filtro + ' AND ' + termo : filtro;
        }
      });
    }
  }

  /* ---------- Carrosséis (produtos e coleções) ---------- */
  function iniciarCarrossel(caixa) {
    if (caixa.dataset.dgPronto) return;
    caixa.dataset.dgPronto = '1';
    var trilho = $('[data-dg-scroller]', caixa);
    var ant = $('[data-dg-prev]', caixa);
    var prox = $('[data-dg-next]', caixa);
    if (!trilho) return;

    var atualizar = function () {
      var max = trilho.scrollWidth - trilho.clientWidth - 2;
      if (ant) ant.disabled = trilho.scrollLeft <= 2;
      if (prox) prox.disabled = trilho.scrollLeft >= max;
    };
    var passo = function () {
      var item = trilho.firstElementChild;
      if (!item) return trilho.clientWidth;
      var porTela = Math.max(1, Math.round(trilho.clientWidth / item.getBoundingClientRect().width));
      return item.getBoundingClientRect().width * Math.max(1, porTela - 1);
    };
    if (ant) ant.addEventListener('click', function () { trilho.scrollBy({ left: -passo() }); });
    if (prox) prox.addEventListener('click', function () { trilho.scrollBy({ left: passo() }); });
    trilho.addEventListener('scroll', atualizar, { passive: true });
    window.addEventListener('resize', atualizar);
    atualizar();
  }

  /* ---------- Slideshow ---------- */
  function iniciarSlideshow(caixa) {
    var trilho = $('[data-dg-track]', caixa);
    var pontos = $$('.dg-slideshow__dot', caixa);
    if (!trilho || pontos.length < 2) return;
    var n = pontos.length;

    // Rolagem infinita: cópia do último banner no começo e do primeiro no fim.
    // Quando o trilho para numa cópia, pula (sem animação) para o banner verdadeiro.
    var slides = $$('.dg-slideshow__slide', trilho);
    // Todos os banners baixam já ao abrir a página e aparecem sem o fade:
    // senão o vizinho (e a cópia dele) surge em branco ao arrastar.
    var semAtraso = function (raiz) {
      $$('img', raiz).forEach(function (im) {
        im.setAttribute('loading', 'eager');
        im.classList.remove('dg-fade');
      });
    };
    slides.forEach(semAtraso);
    var copia = function (el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      semAtraso(c);
      return c;
    };
    trilho.insertBefore(copia(slides[n - 1]), slides[0]);
    trilho.appendChild(copia(slides[0]));

    var largura = function () { return trilho.clientWidth; };
    var fisico = function () { return Math.round(trilho.scrollLeft / largura()); };
    var semAnimacao = function (pos) {
      trilho.classList.add('is-arrastando');
      trilho.scrollLeft = largura() * pos;
      requestAnimationFrame(function () { trilho.classList.remove('is-arrastando'); });
    };
    var marcar = function (f) {
      var real = ((f - 1) % n + n) % n;
      pontos.forEach(function (p, j) { p.setAttribute('aria-current', String(j === real)); });
      return real;
    };
    var irFisico = function (f) {
      f = Math.max(0, Math.min(n + 1, f));
      trilho.scrollTo({ left: largura() * f });
      marcar(f);
    };
    var arrumar = function () {
      var f = fisico();
      if (f <= 0) semAnimacao(n);
      else if (f >= n + 1) semAnimacao(1);
      marcar(fisico());
    };
    semAnimacao(1);
    window.addEventListener('resize', function () { semAnimacao(marcar(fisico()) + 1); });

    var arrasto = null;
    var parada = null;
    trilho.addEventListener('scroll', function () {
      marcar(fisico());
      clearTimeout(parada);
      parada = setTimeout(function () { if (!arrasto) arrumar(); }, 140);
    }, { passive: true });

    pontos.forEach(function (p, i) {
      p.addEventListener('click', function () { irFisico(i + 1); reiniciar(); });
    });

    var timer = null;
    var reiniciar = function () {
      if (caixa.dataset.autoplay !== 'true') return;
      clearInterval(timer);
      timer = setInterval(function () { irFisico(fisico() + 1); }, (parseInt(caixa.dataset.intervalo, 10) || 5) * 1000);
    };
    caixa.addEventListener('mouseenter', function () { clearInterval(timer); });
    caixa.addEventListener('mouseleave', reiniciar);

    // Arrastar com o mouse ou com o dedo (igual Mimers): segue o dedo e, ao soltar, vai para o banner vizinho.
    trilho.style.touchAction = 'pan-y';
    trilho.addEventListener('dragstart', function (e) { e.preventDefault(); });
    trilho.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      clearInterval(timer);
      arrumar();
      arrasto = { x: e.clientX, y: e.clientY, inicio: trilho.scrollLeft, base: fisico(), t: Date.now(), moveu: false, id: e.pointerId };
    });
    trilho.addEventListener('pointermove', function (e) {
      if (!arrasto || e.pointerId !== arrasto.id) return;
      var dx = e.clientX - arrasto.x;
      if (!arrasto.moveu) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(e.clientY - arrasto.y) > Math.abs(dx)) { arrasto = null; reiniciar(); return; }
        arrasto.moveu = true;
        trilho.classList.add('is-arrastando');
        try { trilho.setPointerCapture(e.pointerId); } catch (er) {}
      }
      trilho.scrollLeft = arrasto.inicio - dx;
    });
    var soltar = function (e) {
      if (!arrasto || e.pointerId !== arrasto.id) return;
      var a = arrasto;
      arrasto = null;
      if (a.moveu) {
        var dx = e.clientX - a.x;
        var rapido = Math.abs(dx) / Math.max(1, Date.now() - a.t) > 0.4;
        var destino = a.base;
        if (Math.abs(dx) > largura() * 0.15 || (rapido && Math.abs(dx) > 20)) destino = a.base + (dx < 0 ? 1 : -1);
        trilho.classList.remove('is-arrastando');
        trilho.dataset.arrastou = '1';
        setTimeout(function () { delete trilho.dataset.arrastou; }, 50);
        irFisico(destino);
      }
      reiniciar();
    };
    trilho.addEventListener('pointerup', soltar);
    trilho.addEventListener('pointercancel', soltar);
    // Um arrasto não abre o link do banner.
    trilho.addEventListener('click', function (e) {
      if (trilho.dataset.arrastou) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    reiniciar();
  }

  /* ---------- Página do produto ---------- */
  function iniciarProduto(raiz) {
    var variantes = [];
    try { variantes = JSON.parse($('[data-dg-variantes]', raiz).textContent); } catch (e) {}
    var form = $('[data-dg-form]', raiz) || $('form[action*="/cart/add"]', raiz);
    var campoId = $('[data-dg-variant-id]', raiz);
    var botao = $('[data-dg-buy]', raiz);
    var textoBotao = botao ? botao.textContent.trim() : '';
    if (botao && botao.disabled) textoBotao = 'Comprar agora';
    var palco = $('[data-dg-stage]', raiz);

    // Card de compra (PC): a altura dele vira --dg-info-h para o sticky grudar pelo FIM do card.
    var cardInfo = $('.dg-info', raiz);
    if (cardInfo && window.ResizeObserver) {
      var medirInfo = function () {
        cardInfo.style.setProperty('--dg-info-h', cardInfo.offsetHeight + 'px');
        // Barra preta do Shopify (só aparece pro dono logado) cobre o rodapé da tela.
        var barra = document.getElementById('PBarNextFrameWrapper');
        cardInfo.style.setProperty('--dg-pbar-h', (barra ? barra.getBoundingClientRect().height : 0) + 'px');
      };
      new ResizeObserver(medirInfo).observe(cardInfo);
      window.addEventListener('resize', medirInfo);
      medirInfo();
      setTimeout(medirInfo, 2000);
      setTimeout(medirInfo, 6000);
    }

    // Galeria
    var mostrarMidia = function (id) {
      if (!id) return;
      var alvo = $('[data-dg-media="' + id + '"]', raiz);
      if (!alvo) return;
      $$('[data-dg-media]', raiz).forEach(function (m) {
        var ativo = m === alvo;
        m.setAttribute('aria-hidden', String(!ativo));
        if (!ativo) { var v = $('video', m); if (v) v.pause(); }
      });
      $$('[data-dg-thumb]', raiz).forEach(function (t) {
        t.setAttribute('aria-current', String(t.dataset.dgThumb === String(id)));
      });
    };
    $$('[data-dg-thumb]', raiz).forEach(function (t) {
      t.addEventListener('click', function () { mostrarMidia(t.dataset.dgThumb); });
    });

    // Player de vídeo da galeria = o mesmo da Mimers (Shopify Plyr, carregado pelo Shopify.loadFeatures):
    // sem o menu "⋮" do navegador (que oferece baixar o vídeo), com play grande e barra limpa.
    var videosGaleria = palco ? $$('[data-dg-media] video', palco) : [];
    var players = [];
    if (videosGaleria.length && window.Shopify && window.Shopify.loadFeatures) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
      document.head.appendChild(css);
      window.Shopify.loadFeatures([{
        name: 'video-ui',
        version: '1.0',
        onLoad: function (erro) {
          if (erro || !window.Shopify.Plyr) return;
          videosGaleria.forEach(function (v) {
            v.removeAttribute('controls');
            v.setAttribute('controlsList', 'nodownload');
            players.push(new window.Shopify.Plyr(v, {
              controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],
              loop: { active: true },
              hideControlsOnPause: true,
              clickToPlay: true,
              iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
              tooltips: { controls: false, seek: true }
            }));
          });
        }
      }]);
    }

    // Deslizar o dedo na foto troca de mídia (celular), como o carrossel da Mimers:
    // a foto atual acompanha o dedo, a vizinha entra pelo lado e ao soltar a troca termina deslizando.
    if (palco) {
      var midias = $$('[data-dg-media]', palco);
      var toque = null;
      var DURACAO = 300;
      var idxAtual = function () {
        var i = midias.findIndex(function (m) { return m.getAttribute('aria-hidden') === 'false'; });
        return i < 0 ? 0 : i;
      };
      var estilo = function (m, x, trans) {
        m.style.transition = trans ? 'transform ' + DURACAO + 'ms ease' : 'none';
        m.style.transform = 'translateX(' + x + 'px)';
        m.style.opacity = '1';
        m.style.visibility = 'visible';
      };
      var limpar = function (m) {
        m.style.transition = 'none';
        m.style.transform = '';
        m.style.opacity = '';
        m.style.visibility = '';
        setTimeout(function () { m.style.transition = ''; }, 50);
      };
      var centralizarMiniatura = function (id) {
        var t = $('[data-dg-thumb="' + id + '"]', raiz);
        var trilho = t && t.parentElement;
        if (!t || !trilho || trilho.scrollWidth <= trilho.clientWidth) return;
        trilho.scrollTo({ left: t.offsetLeft - (trilho.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      };
      palco.addEventListener('touchstart', function (e) {
        if (midias.length < 2 || e.touches.length !== 1) return;
        toque = { x: e.touches[0].clientX, y: e.touches[0].clientY, dx: 0, horizontal: null, w: palco.offsetWidth, i: idxAtual() };
      }, { passive: true });
      palco.addEventListener('touchmove', function (e) {
        if (!toque) return;
        var dx = e.touches[0].clientX - toque.x, dy = e.touches[0].clientY - toque.y;
        if (toque.horizontal === null) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          toque.horizontal = Math.abs(dx) > Math.abs(dy);
        }
        if (!toque.horizontal) { toque = null; return; }
        e.preventDefault();
        toque.dx = dx;
        var atual = midias[toque.i];
        var vizinho = midias[(toque.i + (dx < 0 ? 1 : -1) + midias.length) % midias.length];
        if (toque.vizinho && toque.vizinho !== vizinho) limpar(toque.vizinho);
        toque.vizinho = vizinho;
        estilo(atual, dx, false);
        estilo(vizinho, dx + (dx < 0 ? toque.w : -toque.w), false);
      }, { passive: false });
      palco.addEventListener('touchend', function () {
        if (!toque || !toque.horizontal || !toque.vizinho) { toque = null; return; }
        var t = toque; toque = null;
        var atual = midias[t.i], vizinho = t.vizinho;
        var troca = Math.abs(t.dx) > t.w * 0.18;
        var dir = t.dx < 0 ? -1 : 1;
        if (troca) {
          estilo(atual, dir * t.w, true);
          estilo(vizinho, 0, true);
        } else {
          estilo(atual, 0, true);
          estilo(vizinho, -dir * t.w, true);
        }
        setTimeout(function () {
          if (troca) {
            mostrarMidia(vizinho.dataset.dgMedia);
            centralizarMiniatura(vizinho.dataset.dgMedia);
          }
          limpar(atual);
          limpar(vizinho);
        }, DURACAO + 20);
      });
    }

    // Zoom como a Mimers (só PC com mouse): um quadrado (lente) acompanha o mouse sobre a foto
    // e um painel grande ao lado, por cima da coluna de compra, mostra aquele trecho ampliado.
    if (palco && window.matchMedia('(hover: hover) and (min-width: 1000px)').matches) {
      var ZOOM = 3;
      var lente = document.createElement('div');
      lente.className = 'dg-zoom-lente';
      palco.appendChild(lente);
      var painel = document.createElement('div');
      painel.className = 'dg-zoom-painel';
      document.body.appendChild(painel);
      var colunaInfo = $('.dg-info', raiz);
      // vídeo não tem zoom (o video_tag traz uma <img> de capa dentro: não pode contar como foto)
      var imgAtiva = function () {
        var m = $('[aria-hidden="false"]', palco);
        if (!m || $('video, iframe', m)) return null;
        return $('img', m);
      };
      var urlGrande = function (img) {
        var u = img.currentSrc || img.src;
        return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$12000') : u;
      };
      var esconder = function () { lente.classList.remove('ativo'); painel.classList.remove('ativo'); };
      palco.addEventListener('mousemove', function (e) {
        var img = imgAtiva();
        if (!img || !img.naturalWidth) { esconder(); return; }
        var p = palco.getBoundingClientRect();
        // área real da foto dentro do palco (object-fit: contain)
        var esc = Math.min(p.width / img.naturalWidth, p.height / img.naturalHeight);
        var fw = img.naturalWidth * esc, fh = img.naturalHeight * esc;
        var fx = (p.width - fw) / 2, fy = (p.height - fh) / 2;
        var x = e.clientX - p.left - fx, y = e.clientY - p.top - fy;
        if (x < 0 || y < 0 || x > fw || y > fh) { esconder(); return; }
        var info = colunaInfo ? colunaInfo.getBoundingClientRect() : { left: p.right + 30, width: p.width };
        var tam = Math.min(info.width, 520, window.innerHeight - p.top - 10);
        var lado = tam / ZOOM;
        var lx = Math.max(0, Math.min(fw - lado, x - lado / 2));
        var ly = Math.max(0, Math.min(fh - lado, y - lado / 2));
        lente.style.cssText = 'width:' + lado + 'px;height:' + lado + 'px;left:' + (fx + lx) + 'px;top:' + (fy + ly) + 'px';
        lente.classList.add('ativo');
        var bg = urlGrande(img);
        if (painel.dataset.bg !== bg) { painel.style.backgroundImage = 'url("' + bg + '")'; painel.dataset.bg = bg; }
        painel.classList.add('ativo');
        painel.style.width = tam + 'px';
        painel.style.height = tam + 'px';
        painel.style.left = info.left + 'px';
        painel.style.top = Math.max(p.top, 0) + 'px';
        painel.style.backgroundSize = (fw * ZOOM) + 'px ' + (fh * ZOOM) + 'px';
        painel.style.backgroundPosition = (-lx * ZOOM) + 'px ' + (-ly * ZOOM) + 'px';
      });
      palco.addEventListener('mouseleave', esconder);
      window.addEventListener('scroll', esconder, true);
    }

    // Imagens não podem ser arrastadas (o CSS -webkit-user-drag cobre Chrome/Safari; isto cobre o Firefox)
    raiz.addEventListener('dragstart', function (e) {
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    });

    // Quantidade
    $$('[data-dg-qty]', raiz).forEach(function (b) {
      b.addEventListener('click', function () {
        var campo = $('input[name="quantity"]', raiz);
        var n = Math.max(1, (parseInt(campo.value, 10) || 1) + parseInt(b.dataset.dgQty, 10));
        campo.value = n;
      });
    });

    // Variantes
    var opcoes = $$('[data-dg-option]', raiz);
    var selecionados = function () {
      return opcoes.map(function (op) {
        var sel = $('[data-dg-select]', op);
        if (sel) return sel.value;
        var ativo = $('[aria-pressed="true"]', op);
        return ativo ? ativo.dataset.dgValue : null;
      });
    };
    var acharVariante = function (vals) {
      return variantes.find(function (v) {
        return v.options.every(function (o, i) { return vals[i] == null || o === vals[i]; });
      });
    };
    // Cada opção só olha as anteriores: a cor fica riscada só se não tiver nenhum tamanho à venda,
    // e o tamanho fica riscado se não existir na cor escolhida (ex.: Rosa sem P).
    var disponivelCom = function (vals) {
      return variantes.some(function (v) {
        return v.available && v.options.every(function (o, i) { return vals[i] == null || o === vals[i]; });
      });
    };
    var marcarIndisponiveis = function (vals) {
      opcoes.forEach(function (op, i) {
        $$('[data-dg-value]', op).forEach(function (b) {
          var teste = vals.slice(0, i);
          teste[i] = b.dataset.dgValue;
          b.dataset.indisponivel = String(!disponivelCom(teste));
        });
      });
    };
    var aplicarValores = function (vals) {
      opcoes.forEach(function (op, i) {
        var sel = $('[data-dg-select]', op);
        if (sel) { sel.value = vals[i]; return; }
        $$('[data-dg-value]', op).forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.dgValue === vals[i])); });
      });
    };
    // Escolheu uma combinação que não existe (ex.: Rosa com P marcado): mantém o que foi clicado
    // e pula para a primeira variante à venda com ele.
    var corrigirCombinacao = function (i) {
      var vals = selecionados();
      var atual = acharVariante(vals);
      if (atual && atual.available) return;
      var fixos = vals.slice(0, i + 1);
      var alvo = variantes.find(function (v) {
        return v.available && v.options.every(function (o, k) { return fixos[k] == null || o === fixos[k]; });
      });
      if (alvo) aplicarValores(alvo.options);
    };
    var atualizarPreco = function (variante) {
      var url = raiz.dataset.url + '?variant=' + variante.id + '&section_id=' + raiz.dataset.section;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var novo = doc.querySelector('[data-dg-preco-wrap]');
          var velho = $('[data-dg-preco-wrap]', raiz);
          if (novo && velho) velho.replaceWith(novo);
        })
        .catch(function () {});
    };
    var aoMudar = function () {
      var vals = selecionados();
      opcoes.forEach(function (op, i) {
        var rotulo = $('[data-dg-option-label]', op);
        if (rotulo) rotulo.textContent = (vals[i] || '').split(' - ')[0];
      });
      var variante = acharVariante(vals);
      marcarIndisponiveis(vals);
      if (!variante) {
        if (botao) { botao.disabled = true; botao.textContent = 'Indisponível'; }
        return;
      }
      if (campoId) campoId.value = variante.id;
      if (botao) {
        botao.disabled = !variante.available;
        botao.textContent = variante.available ? textoBotao : 'Esgotado';
      }
      if (variante.featured_media) mostrarMidia(variante.featured_media.id);
      history.replaceState(null, '', raiz.dataset.url + '?variant=' + variante.id);
      atualizarPreco(variante);
    };
    opcoes.forEach(function (op, i) {
      var sel = $('[data-dg-select]', op);
      if (sel) sel.addEventListener('change', function () { corrigirCombinacao(i); aoMudar(); });
      $$('[data-dg-value]', op).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-dg-value]', op).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          corrigirCombinacao(i);
          aoMudar();
        });
      });
    });
    if (opcoes.length) marcarIndisponiveis(selecionados());

    if (form) {
      form.addEventListener('submit', function () {
        if (botao) { botao.disabled = true; botao.textContent = 'Aguarde...'; }
        setTimeout(function () { if (botao) { botao.disabled = false; botao.textContent = textoBotao; } }, 6000);
      });
    }
  }

  /* ---------- Recomendados e vistos ---------- */
  function iniciarRecomendacoes(secao) {
    fetch(secao.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.querySelector('[data-dg-recomendacoes]');
        if (!novo || !novo.innerHTML.trim()) return;
        secao.innerHTML = novo.innerHTML;
        iniciarFade(secao);
        $$('[data-dg-carousel]', secao).forEach(iniciarCarrossel);
      })
      .catch(function () {});
  }

  function iniciarVistos(secao) {
    var lista = [];
    try { lista = JSON.parse(localStorage.getItem('dg-vistos') || '[]'); } catch (e) {}
    var atual = secao.dataset.atual;
    lista = lista.filter(function (h) { return h && h !== atual; }).slice(0, parseInt(secao.dataset.limite, 10) || 5);
    if (!lista.length) return;
    Promise.all(lista.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=dg-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cartoes) {
      var html = cartoes.filter(function (c) { return c.indexOf('dg-item') > -1; }).join('');
      if (!html) return;
      $('[data-dg-scroller]', secao).innerHTML = html;
      secao.hidden = false;
      iniciarFade(secao);
      $$('[data-dg-carousel]', secao).forEach(iniciarCarrossel);
    });
  }

  /* ---------- Coleção ---------- */
  function iniciarColecao(raiz) {
    var ordenar = $('[data-dg-ordenar]', raiz);
    if (ordenar) {
      ordenar.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', ordenar.value);
        url.searchParams.delete('page');
        if (window.dgCarregando) window.dgCarregando();
        window.location.href = url.toString();
      });
    }
    var grade = $('[data-dg-grid]', raiz);
    var botoes = $$('[data-dg-view]', raiz);
    var aplicar = function (modo) {
      if (grade) grade.classList.toggle('dg-grid--lista', modo === 'lista');
      botoes.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.dgView === modo)); });
    };
    var salvo = 'grade';
    try { salvo = localStorage.getItem('dg-visualizacao') || 'grade'; } catch (e) {}
    aplicar(salvo);
    botoes.forEach(function (b) {
      b.addEventListener('click', function () {
        aplicar(b.dataset.dgView);
        try { localStorage.setItem('dg-visualizacao', b.dataset.dgView); } catch (e) {}
      });
    });
  }

  /* ---------- Rodapé em sanfona (celular) ---------- */
  function iniciarRodape() {
    $$('[data-dg-footer-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 1000px)').matches) return;
        var col = b.closest('.dg-footer__col');
        var aberto = col.classList.toggle('is-aberto');
        b.setAttribute('aria-expanded', String(aberto));
      });
    });
  }

  /* ---------- Garantias: bolinhas do carrossel no celular ---------- */
  function iniciarIcones(lista) {
    var pontos = $$('button', lista.parentElement.querySelector('[data-dg-icons-dots]') || document.createElement('div'));
    if (!pontos.length) return;
    pontos.forEach(function (p, i) {
      p.addEventListener('click', function () { lista.scrollTo({ left: lista.clientWidth * i }); });
    });
    lista.addEventListener('scroll', function () {
      var i = Math.round(lista.scrollLeft / Math.max(1, lista.clientWidth));
      pontos.forEach(function (p, j) { p.setAttribute('aria-current', String(i === j)); });
    }, { passive: true });
  }

  /* ---------- Barrinha de carregamento ao trocar de página ---------- */
  function iniciarCarregamento() {
    var barra = $('[data-dg-loading]');
    if (!barra) return;
    var iniciarBarra = function () {
      barra.classList.add('is-ativo');
      barra.style.width = '35%';
      setTimeout(function () { barra.style.width = '70%'; }, 250);
      setTimeout(function () { barra.style.width = '88%'; }, 1200);
    };
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin || url.hash && url.pathname === location.pathname) return;
      iniciarBarra();
    });
    document.addEventListener('submit', function (e) { if (!e.defaultPrevented) iniciarBarra(); });
    window.dgCarregando = iniciarBarra;
    window.addEventListener('pageshow', function () { barra.classList.remove('is-ativo'); barra.style.width = '0'; });
  }

  /* ---------- Imagens aparecem suavemente ao carregar ---------- */
  function iniciarFade(raiz) {
    $$('.dg img[loading="lazy"]', raiz).forEach(function (img) {
      // A 2ª foto do cartão só aparece no hover: o fade deixaria ela por cima da 1ª ao carregar.
      if (img.complete || img.classList.contains('dg-fade') || img.classList.contains('dg-item__img2')) return;
      img.classList.add('dg-fade');
      var pronto = function () { img.classList.add('is-carregada'); };
      img.addEventListener('load', pronto, { once: true });
      img.addEventListener('error', pronto, { once: true });
    });
  }

  // Avaliações: filtro por nota, ordem, "ver mais", fotos ampliadas e o formulário em 2 passos
  // (o envio vai pelo formulário de contato da Shopify e chega no e-mail da loja).
  function iniciarAvaliacoes(secao) {
    var porPagina = parseInt(secao.dataset.porPagina, 10) || 5;
    var lista = $('[data-dg-av-lista]', secao);
    var contagem = $('[data-dg-av-contagem]', secao);
    var mais = $('.dg-avaliacoes__mais', secao);
    var filtro = $('[data-dg-av-filtro]', secao);
    var ordem = $('[data-dg-av-ordem]', secao);
    var mostrar = porPagina;

    function atualizar() {
      if (!lista) return;
      var itens = $$('.dg-avaliacao', lista);
      var f = filtro.value;
      var o = ordem.value;
      itens.sort(function (a, b) {
        var da = +a.dataset.data, db = +b.dataset.data;
        var na = +a.dataset.nota, nb = +b.dataset.nota;
        var pos = +a.dataset.ordem - +b.dataset.ordem;
        if (o === 'antigas') return da - db || -pos;
        if (o === 'maior') return nb - na || db - da || pos;
        if (o === 'menor') return na - nb || db - da || pos;
        return db - da || pos;
      });
      var total = 0;
      itens.forEach(function (it) {
        lista.appendChild(it);
        var passa = !f || (f === 'fotos' ? +it.dataset.fotos > 0 : it.dataset.nota === f);
        if (passa) total++;
        it.hidden = !passa || total > mostrar;
      });
      var mostrados = Math.min(total, mostrar);
      var palavra = total === 1 ? 'Avaliação' : 'Avaliações';
      contagem.textContent = total ? 'Mostrando 1 - ' + mostrados + ' de ' + total + ' ' + palavra : 'Nenhuma avaliação com esse filtro';
      mais.hidden = total <= mostrar;
    }
    if (lista) {
      filtro.addEventListener('change', function () { mostrar = porPagina; atualizar(); });
      ordem.addEventListener('change', function () { mostrar = porPagina; atualizar(); });
      $('[data-dg-av-mais]', secao).addEventListener('click', function () { mostrar += porPagina; atualizar(); });
      atualizar();
    }

    // Foto ou vídeo ampliado
    var zoom = $('[data-dg-av-zoom]', secao);
    var zoomImg = $('[data-dg-av-zoom-img]', secao);
    var zoomVideo = $('[data-dg-av-zoom-video]', secao);
    $$('[data-dg-av-foto]', secao).forEach(function (b) {
      b.addEventListener('click', function () {
        var video = b.hasAttribute('data-video');
        zoomImg.hidden = video;
        zoomVideo.hidden = !video;
        if (video) {
          zoomVideo.src = b.dataset.dgAvFoto;
        } else {
          zoomImg.src = b.dataset.dgAvFoto;
        }
        if (zoom.showModal) zoom.showModal();
        if (video) zoomVideo.play().catch(function () {});
      });
    });
    zoom.addEventListener('close', function () {
      zoomVideo.pause();
      zoomVideo.removeAttribute('src');
      zoomVideo.load();
    });

    // Formulário
    var modal = $('[data-dg-av-modal]', secao);
    var form = $('[data-dg-av-form]', secao);
    var passo1 = $('[data-dg-av-passo="1"]', secao);
    var passo2 = $('[data-dg-av-passo="2"]', secao);
    var ok = $('[data-dg-av-ok]', secao);
    var notaCampo = $('[data-dg-av-nota-campo]', secao);
    var estrelas = $$('[data-dg-av-nota] button', secao);

    function marcarNota(v) {
      notaCampo.value = v;
      estrelas.forEach(function (e) {
        var ativa = +e.dataset.valor <= v;
        e.classList.toggle('is-ativa', ativa);
        e.setAttribute('aria-checked', String(+e.dataset.valor === v));
      });
    }
    estrelas.forEach(function (e) {
      e.addEventListener('click', function () { marcarNota(+e.dataset.valor); });
      e.addEventListener('mouseenter', function () {
        estrelas.forEach(function (x) { x.classList.toggle('is-ativa', +x.dataset.valor <= +e.dataset.valor); });
      });
    });
    $('[data-dg-av-nota]', secao).addEventListener('mouseleave', function () { marcarNota(+notaCampo.value); });

    function irPasso(n) {
      passo1.hidden = n !== 1;
      passo2.hidden = n !== 2;
      ok.hidden = n !== 3;
      var campo = $(n === 1 ? 'textarea' : 'input[type="text"]', n === 1 ? passo1 : passo2);
      if (campo && n !== 3) campo.focus();
    }

    $$('[data-dg-av-abrir]', secao).forEach(function (b) {
      b.addEventListener('click', function () {
        irPasso(1);
        if (modal.showModal) modal.showModal();
      });
    });
    $$('[data-dg-av-fechar]', secao).forEach(function (b) {
      b.addEventListener('click', function () { b.closest('dialog').close(); });
    });
    [modal, zoom].forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });

    $('[data-dg-av-proximo]', secao).addEventListener('click', function () {
      var vazio = !$('textarea', passo1).value.trim();
      $('[data-dg-av-erro]', secao).hidden = !vazio;
      if (!vazio) irPasso(2);
    });
    $('[data-dg-av-voltar]', secao).addEventListener('click', function () { irPasso(1); });

    // Anexos: até 5 fotos/vídeos. Sobem um por vez para o servidor de mídia da Doguers
    // na hora de enviar; os links vão no campo "Fotos e vídeos" do e-mail.
    var MAX_ANEXOS = 5;
    var MB = 1024 * 1024;
    var anexos = [];
    var caixaAnexos = $('[data-dg-av-anexos]', secao);
    var botaoAnexar = $('[data-dg-av-anexar]', secao);
    var campoArquivos = $('[data-dg-av-arquivos]', secao);
    var campoLinks = $('[data-dg-av-links]', secao);
    var progresso = $('[data-dg-av-progresso]', secao);
    var erroAnexo = document.createElement('p');
    erroAnexo.className = 'dg-av-modal__erro';
    erroAnexo.hidden = true;
    caixaAnexos.insertAdjacentElement('afterend', erroAnexo);

    function avisoAnexo(texto) {
      erroAnexo.textContent = texto || '';
      erroAnexo.hidden = !texto;
    }

    function desenharAnexos() {
      $$('.dg-av-modal__anexo', caixaAnexos).forEach(function (el) { el.remove(); });
      anexos.forEach(function (a, i) {
        var item = document.createElement('div');
        item.className = 'dg-av-modal__anexo';
        var previa = document.createElement(a.video ? 'video' : 'img');
        previa.src = a.previa;
        if (a.video) {
          previa.muted = true;
          previa.playsInline = true;
          previa.preload = 'metadata';
        } else {
          previa.alt = '';
        }
        item.appendChild(previa);
        if (a.video) {
          var selo = document.createElement('span');
          selo.className = 'dg-avaliacoes__play';
          selo.innerHTML = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1v8l7-4z" fill="currentColor"/></svg>';
          item.appendChild(selo);
        }
        var tirar = document.createElement('button');
        tirar.type = 'button';
        tirar.className = 'dg-av-modal__tirar';
        tirar.setAttribute('aria-label', 'Remover');
        tirar.textContent = '×';
        tirar.addEventListener('click', function () {
          URL.revokeObjectURL(a.previa);
          anexos.splice(i, 1);
          avisoAnexo('');
          desenharAnexos();
        });
        item.appendChild(tirar);
        caixaAnexos.insertBefore(item, botaoAnexar);
      });
      botaoAnexar.hidden = anexos.length >= MAX_ANEXOS;
    }

    campoArquivos.addEventListener('change', function () {
      var problema = '';
      Array.prototype.forEach.call(campoArquivos.files, function (f) {
        var video = /^video\//.test(f.type) || /\.(mp4|mov|webm)$/i.test(f.name);
        var foto = /^image\//.test(f.type) || /\.(jpe?g|png|webp|heic|heif|gif)$/i.test(f.name);
        if (!video && !foto) { problema = 'Envie só fotos ou vídeos.'; return; }
        if (f.size > (video ? 80 : 15) * MB) { problema = video ? 'Cada vídeo pode ter até 80 MB.' : 'Cada foto pode ter até 15 MB.'; return; }
        if (anexos.length >= MAX_ANEXOS) { problema = 'Máximo de 5 arquivos.'; return; }
        anexos.push({ arquivo: f, video: video, previa: URL.createObjectURL(f), url: '' });
      });
      campoArquivos.value = '';
      avisoAnexo(problema);
      desenharAnexos();
    });

    function subir(a, n) {
      return new Promise(function (ok, falha) {
        if (a.url) return ok(a.url);
        var dados = new FormData();
        dados.append('arquivo', a.arquivo, a.arquivo.name);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', secao.dataset.upload);
        xhr.upload.onprogress = function (ev) {
          if (!ev.lengthComputable) return;
          progresso.textContent = 'Enviando arquivo ' + n + ' de ' + anexos.length + '... ' + Math.round((ev.loaded / ev.total) * 100) + '%';
        };
        xhr.onload = function () {
          var r = {};
          try { r = JSON.parse(xhr.responseText); } catch (e) {}
          if (xhr.status === 201 && r.url) {
            a.url = r.url;
            ok(r.url);
          } else {
            falha(new Error(r.erro ? 'Erro: ' + r.erro + '.' : 'Não foi possível enviar o arquivo.'));
          }
        };
        xhr.onerror = function () { falha(new Error('Falha na conexão ao enviar o arquivo.')); };
        xhr.send(dados);
      });
    }

    function subirTodos() {
      var links = [];
      return anexos.reduce(function (p, a, i) {
        return p.then(function () {
          return subir(a, i + 1).then(function (u) { links.push(u); });
        });
      }, Promise.resolve()).then(function () { return links; });
    }

    function limparAnexos() {
      anexos.forEach(function (a) { URL.revokeObjectURL(a.previa); });
      anexos = [];
      campoLinks.value = '';
      avisoAnexo('');
      desenharAnexos();
    }

    form.addEventListener('submit', function (e) {
      var nome = $('input[name="contact[name]"]', form);
      var email = $('input[name="contact[email]"]', form);
      var faltando = !nome.value.trim() || !email.checkValidity();
      $('[data-dg-av-erro2]', secao).hidden = !faltando;
      e.preventDefault();
      if (faltando) return;
      var botao = $('[data-dg-av-enviar]', form);
      botao.disabled = true;
      progresso.hidden = !anexos.length;
      subirTodos()
        .then(function (links) {
          campoLinks.value = links.join('\n');
          progresso.textContent = 'Enviando avaliação...';
          return fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }).then(
            function (r) {
              // Se a Shopify pedir verificação anti-spam, manda pelo envio normal (abre a página dela)
              if (/challenge/.test(r.url)) { form.submit(); return; }
              if (!r.ok) throw new Error('Não foi possível enviar a avaliação.');
              form.reset();
              limparAnexos();
              progresso.hidden = true;
              marcarNota(5);
              irPasso(3);
            },
            function () { form.submit(); }
          );
        })
        .catch(function (erro) {
          // Falha no upload: avisa e deixa tentar de novo (os que já subiram não sobem outra vez)
          progresso.textContent = erro.message + ' Tente de novo ou remova o arquivo.';
          progresso.hidden = false;
        })
        .then(function () { botao.disabled = false; });
    });

    // Volta do envio normal (return_to): mostra o obrigado
    if (/[?&]avaliacao=enviada/.test(location.search) && modal.showModal) {
      irPasso(3);
      modal.showModal();
    }
  }

  // Meu carrinho: muda a quantidade ou remove pela API do carrinho e recarrega a página
  // (a CartPanda reinstala o botão Finalizar compra dela a cada carregamento).
  function iniciarCarrinho(secao) {
    function mudar(linha, quantidade) {
      var item = $('[data-dg-linha="' + linha + '"]', secao);
      if (item) item.classList.add('is-carregando');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +linha, quantity: Math.max(0, quantidade) })
      })
        .then(function () { location.reload(); })
        .catch(function () { location.reload(); });
    }
    $$('[data-dg-linha]', secao).forEach(function (item) {
      var linha = item.dataset.dgLinha;
      var campo = $('[data-dg-qtd-input]', item);
      $$('[data-dg-qtd]', item).forEach(function (b) {
        b.addEventListener('click', function () {
          mudar(linha, (parseInt(campo.value, 10) || 0) + parseInt(b.dataset.dgQtd, 10));
        });
      });
      campo.addEventListener('change', function () { mudar(linha, parseInt(campo.value, 10) || 0); });
      $('[data-dg-remover]', item).addEventListener('click', function () { mudar(linha, 0); });
    });
  }

  function iniciar() {
    iniciarCabecalho();
    iniciarCarregamento();
    iniciarFade(document);
    iniciarRodape();
    $$('[data-dg-icons]').forEach(iniciarIcones);
    $$('[data-dg-carousel]').forEach(iniciarCarrossel);
    $$('[data-dg-slideshow]').forEach(iniciarSlideshow);
    $$('[data-dg-produto]').forEach(iniciarProduto);
    $$('[data-dg-recomendacoes]').forEach(iniciarRecomendacoes);
    $$('[data-dg-vistos]').forEach(iniciarVistos);
    $$('[data-dg-colecao]').forEach(iniciarColecao);
    $$('[data-dg-avaliacoes]').forEach(iniciarAvaliacoes);
    $$('[data-dg-carrinho]').forEach(iniciarCarrinho);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // Editor de temas: reinicia a seção que acabou de ser alterada
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-dg-carousel]', e.target).forEach(iniciarCarrossel);
    $$('[data-dg-slideshow]', e.target).forEach(iniciarSlideshow);
  });
})();
